/// <reference path="../lib/jquery.d.ts" />

import {Controller} from "./helpers/controller";
import {PopupControl, PopupControlConfig} from "./popupControl";

export class FilterControl extends Controller  {
    
    private filterModule = () => $('#filterModule');
    private filterCloseButton = () => this.filterModule().find('[data-filterclose]');
    private pageWrap: JQuery = $('.pageWrap');
    private scrollBackTo: number;
    private html: JQuery = $('html');
    private filterPill: JQuery = $('.filterPills li');
    private currentURL = window.location.href;
 
    constructor(element: HTMLElement) {
        super(element);
        
        this.scrollBackTo = 0

        let config: PopupControlConfig = {
            popupElement: this.filterModule().get()[0],
            openCallback: this.openCallback,
            scrollTo: this.scrollBackTo,
            defaultEvents: true
        }
        let filterPopup = new PopupControl(element,config);

        this.filterPill.on('click',(e) => {
            e.preventDefault();
            
            if (e.target.innerHTML.toLowerCase() == "clear all")
            {
                window.location.href = "/free-resources/"
            }
            
            let category = e.target.id.replace(' ','');
            let categoryUpdated = category[0].toLowerCase() + category.substring(1);

            let filter = e.target.innerHTML.toLowerCase().replace(',', '').replace(' &amp; ', ' ').replace('(', '').replace(')', '').replace('+', '')
            let filterUpdated = filter.split(' ').join('-')

            window.location.href = this.currentURL.replace( "&filters%5B"+ categoryUpdated + "%5D=" + filterUpdated,"").replace("filters%5B"+ categoryUpdated + "%5D=" + filterUpdated,"");
        });
    }
    
    openCallback = () => {
        let pageHeight = this.pageWrap.innerHeight() + "px";
        this.filterModule().css("min-height", pageHeight);
    }
}

